type dataItemTable = {
  key: number,
  code: string,
  name: string,
  dv: string,
  sl: number,
  price: number,
  type: string,
  slReal: number,
  vat: number,
  money: number,
  number: number,
  note: string
};

const dataModalTabPay: Array<dataItemTable> = [
  {
    key: 1,
    code: '',
    name: '',
    dv: '',
    sl: 0,
    price: 0,
    type: '',
    slReal: 0,
    vat: 0,
    money: 0,
    number: 0,
    note: ''
  },

  {
    key: 2,
    code: '',
    name: '',
    dv: '',
    sl: 0,
    price: 0,
    type: '',
    slReal: 0,
    vat: 0,
    money: 0,
    number: 0,
    note: ''
  },
  {
    key: 3,
    code: '',
    name: '',
    dv: '',
    sl: 0,
    price: 0,
    type: '',
    slReal: 0,
    vat: 0,
    money: 0,
    number: 0,
    note: ''
  },
];

export default dataModalTabPay;
